import { render, staticRenderFns } from "./WhiteLabelModal.vue?vue&type=template&id=3067066b&scoped=true&v-if=widgetReady&"
import script from "./WhiteLabelModal.vue?vue&type=script&lang=js&"
export * from "./WhiteLabelModal.vue?vue&type=script&lang=js&"
import style0 from "./WhiteLabelModal.vue?vue&type=style&index=0&id=3067066b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3067066b",
  null
  
)

component.options.__file = "WhiteLabelModal.vue"
export default component.exports